
export const getDomain = () => {
    let domain = window.location.hostname;
    // for local development, but we still want to use
    // keycloak on test server
    if (domain === 'localhost') {
        return 'app.nabu-med.ai';
    }
    return domain;

}